<template>
  <div class="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title>
        Reservas
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-select
                  v-model="typeClient"
                  :items="typesClient"
                  item-text="name"
                  item-value="code"
                  label="Tipo de cliente"
                  prepend-icon="mdi-office-building"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-dialog
                  ref="dialog_begin"
                  v-model="modal_begin"
                  :return-value.sync="begin_date"
                  persistent
                  lazy
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="begin_date"
                      label="Data inicio"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="begin_date"
                    scrollable
                    class="color"
                    :header-color="header_color"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal_begin = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dialog_begin.save(begin_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-dialog
                  ref="dialog_end"
                  v-model="modal_end"
                  :return-value.sync="end_date"
                  persistent
                  lazy
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="end_date"
                      label="Data fim"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="end_date"
                    scrollable
                    :header-color="header_color"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal_end = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dialog_end.save(end_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-btn
                  block
                  color="info"
                  class="mt-3 white--text"
                  @click="filtrar()"
                  >Filtrar</v-btn
                >
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-card-text>
        <v-row class="mb-5" justify="space-between">
          <v-flex xs12 md6 sm6>
            <v-col align="start">
              <v-text-field
                v-model="approver"
                prepend-icon="search"
                label="Procurar"
                single-line
                hide-details
              />
            </v-col>
          </v-flex>

          <v-flex xs12 md3 sm6>
            <v-col align="center">
              <download-excel
                :data="reservationGrid"
                :fields="json_fields"
                name="clientes.xls"
              >
                <v-btn
                  :disabled="reservationGrid.length > 0 ? false : true"
                  block
                  color="success"
                  class="mt-4 white--text"
                >
                  Exportar
                  <v-icon right>mdi-file-excel</v-icon>
                </v-btn>
              </download-excel>
            </v-col>
          </v-flex>
        </v-row>

        <v-row class="ma-6">
          <v-data-table
            no-data-text="nenhuma reserva registrada"
            :headers="headers"
            :items="reservationGrid"
            :search="approver"
            item-key="name"
            group-key="category"
            class="elevation-1"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td class>
                  <ActionButton
                    message="Detalhes da reserva"
                    icon="assignment"
                    color="info"
                    @onclick="detail(item)"
                  />
                </td>
                <td class>{{ item.id }}</td>
                <td class>{{ item.status }}</td>
                <td class>
                  {{
                    item.data_cancelamento
                      ? formatDate(item.data_cancelamento)
                      : '-'
                  }}
                </td>

                <td class>{{ formatDate(item.data_checkin) }}</td>
                <td class>{{ formatDate(item.data_checkout) }}</td>
                <td class>{{ item.nome }}</td>
                <td class>{{ item.vehicle }}</td>
                <td class>{{ item.plate }}</td>
                <td class>{{ item.duracao | formatHour }}</td>
                <td class>{{ item.client }}</td>
                <td class>{{ item.valor_da_reserva | formatValue }}</td>
                <td class>{{ item.valor_quilometragem | formatValue }}</td>
                <td class>{{ item.valor_da_multa | formatValue }}</td>
                <td class>{{ item.valor_estornado | centsToReal }}</td>
                <td class>{{ item.valor_extensao | formatValue }}</td>
                <td class>{{ item.valor_seguro | formatValue }}</td>
                <td class>{{ item.valor_total | formatValue }}</td>
                <td class>{{ !!item.promotion ? item.promotion : '-' }}</td>
                <td class>{{ !!item.coupon ? item.coupon : '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import Constants from '../../models/constants/ConstantsRoutes.js';
import ConfigurationController from '../../controllers/ConfigurationController';
import moment from 'moment';
import Roles from '../../models/Roles';
import ActionButton from '../shared/ActionButtonsTemplate';

export default {
  components: {
    ActionButton,
  },
  data() {
    return {
      profile: localStorage.getItem('profile'),
      header_color: 'blue',
      begin_date: moment()
        .subtract(5, 'days')
        .format('YYYY-MM-DD'),
      end_date: new Date().toISOString().substr(0, 10),
      modal_begin: false,
      modal_end: false,
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      reservationGrid: [],
      service: null,
      approver: '',
      pagination: {
        sortBy: 'id',
        descending: true,
      },
      json_fields: {
        Id: 'id',
        Status: 'status',
        'Data de checkin': 'data_checkin',
        'Data de checkout': 'data_checkout',
        Solicitante: 'nome',
        Veículo: 'vehicle',
        Duração: {
          field: 'duracao',
          callback: value => {
            return this.formatHour(value);
          },
        },
        Cliente: 'client',
        'Valor da reserva': {
          field: 'valor_da_reserva',
          callback: value => {
            return this.formatValue(value);
          },
        },
        'Valor Quilometragem': {
          field: 'valor_quilometragem',
          callback: value => {
            return this.formatValue(value);
          },
        },
        'Valor da multa': {
          field: 'valor_da_multa',
          callback: value => {
            return this.formatValue(value);
          },
        },
        'Valor estornado': {
          field: 'valor_estornado',
          callback: value => {
            return this.centsToReal(value);
          },
        },
        'Valor extensão': {
          field: 'valor_extensao',
          callback: value => {
            return this.formatValue(value);
          },
        },
        'Valor Seguro': {
          field: 'valor_seguro',
          callback: value => {
            return this.formatValue(value);
          },
        },
        'Valor total': {
          field: 'valor_total',
          callback: value => {
            return this.formatValue(value);
          },
        },
        'Km Percorrido': {
          field: 'km_percorrido',
          callback: value => {
            return value / 1000;
          },
        },
        Promoção: 'promotion',
        Cupom: 'coupon',
      },
      headers: [
        { text: 'Ações', value: 'action', sortable: false },
        { text: 'ID', value: 'id' },
        { text: 'Status', value: 'status' },
        { text: 'Data de Cancelamento', value: 'data_cancelamento' },
        { text: 'Check-in', value: 'data_checkin' },
        { text: 'Check-out', value: 'data_checkout' },
        { text: 'Solicitante', value: 'nome' },
        { text: 'Veículo', value: 'vehicle' },
        { text: 'Placa', value: 'plate' },
        { text: 'Duração', value: 'duracao' },
        { text: 'Cliente', value: 'client' },
        { text: 'Valor reserva', value: 'valor_da_reserva' },
        { text: 'Valor quilometragem', value: 'valor_quilometragem' },
        { text: 'Valor multa', value: 'valor_da_multa' },
        { text: 'Valor estornado', value: 'valor_estornado' },
        { text: 'Valor extensão', value: 'valor_extensao' },
        { text: 'Valor seguro', value: 'valor_seguro' },
        { text: 'Valor total', value: 'valor_total' },
        { text: 'Promoção', value: 'promotion' },
        { text: 'Cupom', value: 'coupon' },
      ],
      configurations: {},
      configurationController: new ConfigurationController(this.$resource),
      vehicleRequestController: new VehicleRequestController(this.$resource),
      typesClient: [
        {
          name: 'Todos',
          code: 'all',
        },
        {
          name: 'Condomínio',
          code: 'condominio',
        },
        {
          name: 'Concessionaria',
          code: 'concessionaria',
        },
        {
          name: 'Frotas',
          code: 'frotas',
        },
      ],
    };
  },
  created() {
    this.loadData(this.begin_date, this.end_date);
  },
  methods: {
    formatDate(date) {
      if (date) {
        return moment(date).format('DD[/]MM[/]YYYY HH:mm');
      }
    },

    filtrar() {
      this.loadData(this.begin_date, this.end_date, this.typeClient);
    },

    detail(item) {
      let routeData = this.$router.resolve({
        name: 'tcs-vehicle-request-detail',
        params: {
          id: item.id,
        },
      });
      window.open(routeData.href, '_blank');
      localStorage.setItem('pageBack', Constants.ROUTER_NAME_SERVICE);
    },

    async loadData(begin_date = null, end_date = null, typeClient = null) {
      this.blockScreen = true;
      try {
        let response = null;
        if (this.profile == Roles.Tcs) {
          response = await this.vehicleRequestController.getReservationReport(
            begin_date,
            end_date,
            typeClient
          );
        } else {
          response = await this.vehicleRequestController.getReservationReport(
            begin_date,
            end_date,
            typeClient,
            localStorage.getItem('client_id')
          );
        }
        if (response.ok) {
          this.reservationGrid = response.data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.blockScreen = false;
      }
    },

    formatHour(valor) {
      let horas = '00';
      let minutos = '00';
      if (valor.hours) {
        if (valor.hours < 10) horas = '0' + valor.hours;
        else horas = valor.hours;
      }
      if (valor.minutes) {
        if (valor.minutes < 10) minutos = '0' + valor.minutes;
        else minutos = valor.minutes;
      }
      if (valor.days) {
        return `${valor.days} dia(s) ${horas} : ${minutos}`;
      }
      return horas + ':' + minutos;
    },

    formatValue(value) {
      let valorFloat = parseFloat(value);
      let formatado = 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
      return formatado;
    },
    centsToReal(cents) {
      cents = (cents / 100).toFixed(2).replace('.', ',');
      return cents;
    },
  },
  filters: {
    formatHour(valor) {
      let horas = '00';
      let minutos = '00';
      if (valor.hours) {
        if (valor.hours < 10) horas = '0' + valor.hours;
        else horas = valor.hours;
      }
      if (valor.minutes) {
        if (valor.minutes < 10) minutos = '0' + valor.minutes;
        else minutos = valor.minutes;
      }
      if (valor.days) {
        return `${valor.days} dia(s) ${horas} : ${minutos}`;
      }
      return horas + ':' + minutos;
    },

    formatValue(value) {
      let valorFloat = parseFloat(value);
      let formatado = 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
      return formatado;
    },
    centsToReal(cents) {
      cents = (cents / 100).toFixed(2).replace('.', ',');
      return 'R$ ' + cents;
    },
  },
};
</script>

<style lang="scss">
.action-list button {
  float: right;
}
.table-custom-vue {
  margin: 20px;
}

.filtro-button {
  background: var(--primary-color-hover) !important;
}
</style>
